import { useState } from 'react';
import { Box, Typography, IconButton } from "@mui/material";
import CompanyMapCard from "../../components/CompanyMapCard";
import { Profile } from "./types";
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { GeographicArea } from 'org-graph/geographicSelection';

interface CompanyMapPanelProps {
  profile: Profile;
  hiddenNodeIds: Set<string>;
  selectedDate: string | null;
  onDateChange: (date: string | null) => void;
  onClose?: () => void;
  geographicArea: GeographicArea | null;
  geographicCompanyIds: ReadonlySet<string> | null;
  onGeographicAreaChange: (area: GeographicArea | null) => void;
}

export default function CompanyMapPanel({ profile, hiddenNodeIds, selectedDate, onDateChange, onClose, geographicArea, geographicCompanyIds, onGeographicAreaChange }: CompanyMapPanelProps) {
  const { t } = useTranslation();
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="subtitle2" fontWeight="bold">{t('assessment.details.map')}</Typography>
        {onClose && (
            <IconButton size="small" onClick={onClose} aria-label={t('common.actions.close')}>
                <CloseIcon fontSize="small" />
            </IconButton>
        )}
      </Box>
      <Box sx={isFullscreen ? {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
        bgcolor: 'background.paper'
      } : { 
        flexGrow: 1, 
        position: 'relative',
        overflow: 'hidden'
      }}>
        <CompanyMapCard 
          profile={profile} 
          hiddenNodeIds={hiddenNodeIds} 
          isFullscreen={isFullscreen} 
          onToggleFullscreen={() => setIsFullscreen(!isFullscreen)} 
          selectedDate={selectedDate} 
          onDateChange={onDateChange}
          geographicArea={geographicArea}
          geographicCompanyIds={geographicCompanyIds}
          onGeographicAreaChange={onGeographicAreaChange}
        />
      </Box>
    </Box>
  );
}
